import { useTranslation } from 'react-i18next';
import { MarketingCardContent } from '../HostfullyAccounting.constants';
import {
  CardBullet,
  CardBulletList,
  CardDescription,
  CardIcon,
  CardTitle,
  MarketingCard,
} from '../HostfullyAccountingMarketing.styles';

interface MarketingContentCardProps {
  card: MarketingCardContent;
}

const MarketingContentCard = ({ card }: MarketingContentCardProps) => {
  const { t } = useTranslation();
  const { Icon, titleKey, descriptionKey, bulletKeys, testId } = card;

  return (
    <MarketingCard data-testid={testId}>
      <CardIcon>
        <Icon aria-hidden />
      </CardIcon>
      <CardTitle>{t(titleKey)}</CardTitle>
      <CardDescription>{t(descriptionKey)}</CardDescription>
      {bulletKeys && (
        <CardBulletList>
          {bulletKeys.map((bulletKey) => (
            <CardBullet key={bulletKey}>{t(bulletKey)}</CardBullet>
          ))}
        </CardBulletList>
      )}
    </MarketingCard>
  );
};

export default MarketingContentCard;
